<template>
  <div class="view-content" style="height: 100%;">
    <!-- ===== 列表模式 ===== -->
    <div v-if="!isAdd">
      <div class="search-box">
        <el-form :model="search" :inline="true" ref="searchFrom" size="small">
          <el-form-item label="名称:" prop="searchName">
            <el-input v-model="search.searchName" placeholder="名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" size="small">搜索</el-button>
            <el-button @click="handleReset" size="small">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="tools-box">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handAdd">
          添加二维码
        </el-button>
      </div>

      <el-table
        :data="tableData"
        border
        style="width: 100%"
        max-height="600"
        size="small"
        :header-cell-style="{
          background: '#f5f5f5',
          color: '#000',
          fontWeight: 'bold',
          align: 'center',
        }"
      >
        <el-table-column
          prop="qrName"
          label="二维码名称"
          width="180"
          show-overflow-tooltip
          align="center"
        />
        <el-table-column
          prop="qrCodeNo"
          label="二维码编号"
          show-overflow-tooltip
          align="center"
        />
        <el-table-column
          prop="qrCodeUrl"
          label="二维码链接"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <div class="qr-wrapper">
              <el-image
                :src="scope.row.qrCodeUrl"
                class="qr-thumb"
                fit="cover"
                :preview-src-list="[scope.row.qrCodeUrl]"
                :z-index="9999"
              />
              <el-tooltip content="下载二维码" placement="top">
                <i
                  class="el-icon-download download-btn"
                  @click.stop="downloadQrCode(scope.row.qrCodeUrl, scope.row.qrName)"
                ></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="itemName"
          label="推广类目"
          width="150"
          show-overflow-tooltip
          align="center"
        />
        <el-table-column prop="scanTotal" label="总扫码次数" align="center" />
        <el-table-column prop="newCustomerNum" label="新增客户" align="center" />
        <el-table-column prop="orderTotal" label="成交订单数" align="center" />
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">启用</el-tag>
            <el-tag type="info" v-if="scope.row.status == 0">停用</el-tag>
            <el-tag type="danger" v-if="scope.row.status == 2">删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="areaName" label="服务区域" align="center" />
        <el-table-column prop="itemName" label="服务项目" align="center" />
        <el-table-column label="操作" fixed="right" width="220" align="center">
          <template slot-scope="scope">
            <span
              class="el-icon-edit table-btn btn-success"
              @click="handleEdit(scope.row)"
            >
              编辑
            </span>
            <span
              class="el-icon-delete table-btn btn-normal"
              @click="handleStatus(scope.row)"
            >
              删除
            </span>
          </template>
        </el-table-column>
      </el-table>

      <div class="page-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          prev-text="上一页"
          next-text="下一页"
          :current-page.sync="search.pageIndex"
          :page-size.sync="search.pageSize"
          :page-sizes="[10, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>

    <!-- ===== 添加/编辑模式（组件） ===== -->
    
    <AddQrCode
      v-else
      :editRow="editRow"
      @goBack="handleAddBack"
      @success="handleAddSuccess"
    />
  </div>
</template>

<script>
import {
  QueryAreaList,
  ModifyChannelQr,
  GetChannelQrList,
  LogoutChannelQrcode,
  QrcodeGenerate,
  AddQrcode,
  GetServiceItemAllList,
} from "@/api/codeManage/index";
import AddQrCode from "./components/AddQrCode.vue";

export default {
  name: "CodeManage",
  components: { AddQrCode },
  data() {
    return {
      isAdd: false,       // 是否显示添加/编辑页面
      editRow: null,      // 编辑时传入的数据
      search: {
        searchName: "",
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      serviceList: [],
      categoryList: [],
      areaList: [],
    };
  },
  mounted() {
    this.getTableData();
    this.getCategoryList();
    this.getAreaList();
  },
  methods: {
    // ===== 下载二维码 =====
    downloadQrCode(url) {
      if (!url) {
        this.$message.warning("二维码链接不存在");
        return;
      }
      window.open(url, "_blank");
    },

    // ===== 搜索与分页 =====
    handleReset() {
      this.search = this.$options.data().search;
      this.getTableData();
    },
    handleSearch() {
      this.search.pageIndex = 1;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.search.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.search.pageIndex = val;
      this.getTableData();
    },

    // ===== 获取表格数据 =====
    getTableData() {
      GetChannelQrList(this.search).then((res) => {
        if (res.data.isSuccess) {
          this.tableData = res.data.data || [];
          this.total = res.data.total || 0;
        }
      });
    },
    getCategoryList() {
      QrcodeGenerate().then((res) => {
        if (res.data.isSuccess) {
          this.categoryList = res.data.data || [];
        }
      });
    },
    getAreaList() {
      QueryAreaList().then((res) => {
        if (res.data.isSuccess) {
          this.areaList = res.data.data || [];
        }
      });
    },

    // ===== 添加/编辑 =====
    handAdd() {
      this.editRow = null;
      this.isAdd = true;
    },
    handleEdit(row) {
      this.editRow = { ...row };
      this.isAdd = true;
    },

    // ===== 从添加页返回 =====
    handleAddBack() {
      this.isAdd = false;
      this.editRow = null;
    },

    // ===== 添加成功回调 =====
    handleAddSuccess() {
      this.isAdd = false;
      this.editRow = null;
      this.handleSearch();
    },

    // ===== 删除 =====
    async handleStatus(row) {
      let message = await this.$message.delConfirm(
        `<p style="font-size:17px">确定删除吗？</p>
        <p style=" color: #7e7b7b;">删除后不可恢复!</p>`
      );
      if (message) {
        let params = { qrId: row.qrId, status: 2 };
        LogoutChannelQrcode(params).then((res) => {
          if (res.data.isSuccess) {
            this.$message.success(res.data.message);
            this.handleSearch();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.qr-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.qr-thumb {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  border: 1px solid #e8eaed;
  cursor: pointer;
  flex-shrink: 0;
}
.qr-thumb .el-image__inner {
  border-radius: 4px;
}
.download-btn {
  font-size: 16px;
  color: #909399;
  cursor: pointer;
  transition: color 0.2s;
  flex-shrink: 0;
}
.download-btn:hover {
  color: #409eff;
}
</style>